import { ActivatedRouteSnapshot } from '@angular/router';
import { LocationsStore } from '../store/locations.store';
import { inject } from '@angular/core';

export const locationLoadedGuard = async (route: ActivatedRouteSnapshot) => {
  const locationsStore = inject(LocationsStore);
  const locationId = route.paramMap.get('locationId');
  if (!locationId) {
    return false;
  }
  const location = locationsStore.locations()?.find((loc) => loc.id === locationId);
  if (location) {
    return true;
  }
  // We explicitly do not await the loading here to allow the router to proceed immediately.
  // This enables the target component to handle and display its own loading and error states,
  // providing a better user experience (e.g., showing skeletons instead of a blank screen).
  locationsStore.loadItem(locationId);
  return true;
};
